import React, { type ComponentProps, useState } from 'react';
import { Form } from 'ALIASED-antd';
import MobileInput from '@components/Patients/MobileInput/MobileInput';
import { useTranslation } from 'react-i18next';
import { RegistrationFormItem, type RegistrationFormItemProps } from '../RegistrationFormItem';
import { useRegistrationFormInstance } from '../useSelfRegistrationFormInstance';

const NAME = 'tel_other';

export const SecondaryPhoneNumberFormItem = ({
  inputProps,
  ...props
}: RegistrationFormItemProps & { inputProps?: Partial<ComponentProps<typeof MobileInput>> }) => {
  const { t } = useTranslation('common');

  const [isValid, setIsValid] = useState<boolean>();
  const form = useRegistrationFormInstance();

  const watchedValue = Form.useWatch(NAME, form);

  return (
    <RegistrationFormItem
      name={NAME}
      htmlFor="alternative-number-input"
      label={t('Alternative number')}
      validateTrigger="onBlur"
      rules={[
        {
          validator(_, value) {
            // Skip validation if the field is empty or disabled (because BE can set it to "invalid" values)
            if (value === undefined || inputProps?.disabled) return Promise.resolve();

            if (!!value && !isValid) {
              return Promise.reject(new Error(t('This field is invalid')));
            }
            return Promise.resolve();
          }
        }
      ]}
      {...props}
    >
      <div data-testid="alternative-number">
        <MobileInput
          inputId="alternative-number-input"
          mobile={watchedValue}
          setMobile={(tel_other) => form.setFieldsValue({ tel_other })}
          setValidMobile={(isValid) => {
            setIsValid(isValid);
            form?.validateFields([NAME]);
          }}
          autoComplete={false}
          location="self-registration"
          separateTelCode={false}
          {...inputProps}
        />
      </div>
    </RegistrationFormItem>
  );
};
